module.exports = __webpack_public_path__ + "static/media/fulllogo.21ff38bf.png";